import { render, staticRenderFns } from "./xzjlList.vue?vue&type=template&id=0c05597c&scoped=true&"
import script from "./xzjlList.vue?vue&type=script&lang=js&"
export * from "./xzjlList.vue?vue&type=script&lang=js&"
import style0 from "./xzjlList.vue?vue&type=style&index=0&id=0c05597c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c05597c",
  null
  
)

export default component.exports